var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.visible && _vm.dateShow
      ? _vm.__map(_vm.years, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m0: m0,
          }
        })
      : null
  var l1 =
    _vm.visible && _vm.dateShow
      ? _vm.__map(_vm.months, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m1 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m1: m1,
          }
        })
      : null
  var l2 =
    _vm.visible && _vm.dateShow
      ? _vm.__map(_vm.days, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m2 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m2: m2,
          }
        })
      : null
  var l3 =
    _vm.visible && _vm.timeShow
      ? _vm.__map(_vm.hours, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m3 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m3: m3,
          }
        })
      : null
  var l4 =
    _vm.visible && _vm.timeShow
      ? _vm.__map(_vm.minutes, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m4 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m4: m4,
          }
        })
      : null
  var l5 =
    _vm.visible && _vm.timeShow && !_vm.hideSecond
      ? _vm.__map(_vm.seconds, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m5 = _vm.lessThanTen(item)
          return {
            $orig: $orig,
            m5: m5,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
        l2: l2,
        l3: l3,
        l4: l4,
        l5: l5,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }